import { api } from './api'
import type { Config } from '@/types/config'

export const configApi = {
  getWorkspaceConfig: async (orgId: string, wsId: string): Promise<Config> => {
    console.log(`🔍 Fetching config for org ${orgId}, workspace ${wsId}`)
    const response = await api.get<Config>('/config', { 
      isWorkspaceSpecific: true 
    })
    console.log('✅ Fetched workspace config:', response.data)
    return response.data
  },

  updateWorkspaceConfig: async (orgId: string, wsId: string, data: Partial<Config>): Promise<Config> => {
    console.log(`✏️ Updating config for org ${orgId}, workspace ${wsId}:`, data)
    const response = await api.put<Config>('/config', data, { 
      isWorkspaceSpecific: true 
    })
    console.log('✅ Updated workspace config:', response.data)
    return response.data
  }
}